import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const TocStockHeader = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: `toc stock-details-head bg_aqua_white ${!(device === null || device === void 0 ? void 0 : device.isDesktop) && "w-100 "}` }, props.children));
};
export default TocStockHeader;
